import { render, staticRenderFns } from "./RequirementEditTabLog.vue?vue&type=template&id=ef140cbc"
import script from "./RequirementEditTabLog.vue?vue&type=script&lang=js"
export * from "./RequirementEditTabLog.vue?vue&type=script&lang=js"
import style0 from "./RequirementEditTabLog.vue?vue&type=style&index=0&id=ef140cbc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports